import * as React from 'react'
import { useLoadingContext } from './LoadingContext'

export const useLoading = (id: string) => {
  const {
    startLoading: contextStartLoading,
    stopLoading: contextStopLoading,
    updateLoadingMessage,
    isLoading,
    getCurrentMessage
  } = useLoadingContext()

  const startLoading = React.useCallback((message: string, priority?: number) => {
    contextStartLoading(id, message, priority)
  }, [contextStartLoading, id])

  const stopLoading = React.useCallback(() => {
    contextStopLoading(id)
  }, [contextStopLoading, id])

  return {
    startLoading,
    stopLoading,
    updateLoadingMessage: (message: string) => updateLoadingMessage(id, message),
    isLoading: () => isLoading(id),
    currentMessage: getCurrentMessage()
  }
}
